module.exports = __webpack_public_path__ + "static/media/Group_10891.37a66e18.svg";